import useSWR from "swr";
import { NOTI_SETTING } from "@app/constants/LOCALKEYS";
import { getPersistData } from "../persist";

const KEY = NOTI_SETTING;

let swrData: any = getPersistData(KEY);
export function useNotiSetting(initData?: any) {
  const { data, mutate } = useSWR<any>(KEY, async () => {
    if (initData !== undefined) {
      swrData = initData;
    }
    return swrData;
  });

  return {
    data,
    mutate: (value: any) => {
      swrData = value;
      return mutate();
    },
  };
}
